import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import { BlankState, Button } from '@domain-group/suit-theme'

import BulkSelectImageUrl from './assets/select-images.svg'

import type { UseCampaignImagesPayload } from '../../hooks/useCampaignImages'

interface BulkSelectBannerProps {
  campaignImagesPayload: UseCampaignImagesPayload,
}

const BulkSelectBanner = (props: BulkSelectBannerProps) => {
  const {
    campaignImagesPayload: {
      bulkSelecting,
      callbacks: { saveBulkSelectSort },
      isGridView,
    },
  } = props

  if (!bulkSelecting || !isGridView){
    return null
  }

  return (
    <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BulkSelectImageUrl}>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Title>Click on images to sort</BlankState.Title>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>
        You can choose the order in which images are sorted.
        Click on the images to set the order you&apos;d like them to
        appear.
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Paragraph>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Actions>
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCheckCircle} />}
          onClick={() => saveBulkSelectSort()}
          size="medium"
          width="fit-content"
        >
          Save Image Sort
        </Button>
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Actions>
    </BlankState>
  )
}

export default BulkSelectBanner
